// src/components/BarreUnique.jsx — LE HAUT DE L'APP, EN DEUX ÉTAGES (verdict
// Dimitri 2026-09-06, revue arrêt 1 : « le menu doit être sur sa propre
// ligne, sous le bandeau de la marque — pas mélangé avec. Dans mon prototype
// il y a deux étages. ») — la fusion en une ligne du 2026-08-15 est REMPLACÉE,
// structure alignée sur admin-proto.html :
//
//   · ÉTAGE 1 (.head du proto) : lotus 34 px · marque FULLBNBZEN · [flex:1] ·
//     la droite (sync, micro, L'opérateur, pastille FZ·Réglages, Déconnexion)
//     — fond blanc, filet bas, gap 9, padding 9px 13px ;
//   · ÉTAGE 2 (.tabs du proto) : le menu du rôle sur SA ligne — fond #f6f8fa,
//     filet bas, gap 4, padding 6px 8px, flex-wrap (le proto ne défile pas,
//     il replie) ; boutons 8px 14px / 12.5px / radius 8. L'ACTIF garde le
//     marquage d'aujourd'hui (fond #e8f2fa — consigne « comme aujourd'hui »,
//     badges conservés).
//
// ⚠️ LA BARRE RESTE CENTRÉE comme la page : fonds pleine largeur, CONTENU dans
// le gabarit 1100 px (margin auto) — sinon la marque colle au bord gauche
// pendant que la page vit au centre (constat Dimitri à l'écran, conservé).
//
// TÉLÉPHONE (cadrage 2026-08-22, inchangé) : sous 640 px le mot « FULLBNBZEN »
// saute (le lotus reste) ; quand `masquerOngletsEtroit` est posé, la barre du
// BAS porte la navigation → l'étage 2 DISPARAÎT ENTIÈREMENT (pas de bande
// grise vide) — c'est aussi le geste du proto (#app.tel .tabs{display:none}).

import { useRef, useEffect, useState } from 'react'
import { DS } from '../lib/ui'
import { LOGO_B64 } from '../assets/logo'

export default function BarreUnique({ enfants, droite, gauche = null, logo = null, marque = 'FULLBNBZEN', testId, masquerOngletsEtroit = false }) {
  const scrollerRef = useRef(null)
  const [etroit, setEtroit] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia('(max-width: 640px)').matches : false)
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined
    const mq = window.matchMedia('(max-width: 640px)')
    const maj = () => setEtroit(mq.matches)
    mq.addEventListener('change', maj)
    return () => mq.removeEventListener('change', maj)
  }, [])
  // L'onglet actif reste ramené en vue si l'étage 2 devait replier/défiler
  // sur un écran intermédiaire — inoffensif quand tout tient.
  useEffect(() => {
    const actif = scrollerRef.current?.querySelector('[aria-current="page"]')
    if (actif && typeof actif.scrollIntoView === 'function') {
      actif.scrollIntoView({ inline: 'center', block: 'nearest' })
    }
  })
  const ongletsVisibles = !(masquerOngletsEtroit && etroit)
  return (
    <div data-testid={testId}
      style={{ position: 'sticky', top: 0, zIndex: 30 }}>
      {/* ── ÉTAGE 1 — la marque et les accès permanents (.head du proto). ── */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e8edf4' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto',
          padding: etroit ? '9px 12px' : '9px 13px',
          display: 'flex', alignItems: 'center', gap: 9 }}>
          {gauche}
          {/* LOGO_B64 porte DÉJÀ son disque bleu et son lotus aux bonnes
              proportions (vérifié pixel par pixel) : affiché TEL QUEL à 34 px. */}
          <img src={logo || `data:image/png;base64,${LOGO_B64}`} alt="logo"
            style={{ width: 34, height: 34, borderRadius: 10, objectFit: 'cover', flexShrink: 0 }} />
          {!etroit && (
            <span style={{ fontFamily: DS.fontDisplay, fontWeight: 700, fontSize: 15,
              color: '#3d5166', letterSpacing: '.06em', whiteSpace: 'nowrap' }}>
              {marque}
            </span>
          )}
          <span style={{ flex: 1, minWidth: 0 }} />
          {/* DROITE — sync, micro, L'opérateur, pastille, Déconnexion. */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
            {droite}
          </div>
        </div>
      </div>
      {/* ── ÉTAGE 2 — le menu du rôle sur SA ligne (.tabs du proto). ── */}
      {ongletsVisibles && (
        <div style={{ background: '#f6f8fa', borderBottom: '1px solid #e8edf4' }}>
          <div className="fbz-scroll-x" ref={scrollerRef}
            style={{ maxWidth: 1100, margin: '0 auto',
              padding: '6px 8px', display: 'flex', alignItems: 'center',
              gap: 4, flexWrap: 'wrap' }}>
            {enfants}
          </div>
        </div>
      )}
    </div>
  )
}

/** L'onglet de l'étage 2 : tailles du proto (.tabs button — 8px 14px, 12.5px,
 *  radius 8, min-height 42) ; l'ACTIF garde le marquage d'aujourd'hui
 *  (fond #e8f2fa — PAS de corail, il ne sert qu'aux alertes, badges compris). */
export function styleOngletBarre(actif) {
  return {
    display: 'inline-flex', alignItems: 'center', gap: 7,
    padding: '8px 14px', fontSize: 12.5, fontWeight: actif ? 700 : 600,
    color: actif ? '#233240' : '#5c6773',
    background: actif ? '#e8f2fa' : 'none',
    border: 'none', borderRadius: 8, minHeight: 42, cursor: 'pointer',
    whiteSpace: 'nowrap', flexShrink: 0, fontFamily: DS.fontBody,
    transition: 'background .15s, color .15s',
  }
}

/** Couleur d'icône d'onglet. */
export function couleurIconeOnglet(actif) {
  return actif ? '#3d5166' : '#98a2ad'
}
